import React from "react";

import styled from "styled-components/macro";

import FnrButton3 from "UI/FnrButton3";

export default function SignupsFundItSplash() {
  return (
    <Wrapper>
      <div style={{ height: 12 }} />
      Secure payment-processing is included with all Flocknote plans! Sell
      tickets, take payments for events, suggest donations, and more. Simply
      verify your church&apos;s info, and tell us where to deposit the funds.
      <div style={{ height: 8 }} />
      <a href="/fundit" target="_blank" rel="noreferrer">
        <FnrButton3 size="small" color="green">
          Learn More
        </FnrButton3>
      </a>
      <div style={{ height: 12 }} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  max-width: 460px;
  background-image: linear-gradient(
    197deg,
    rgb(1, 96, 153) 0%,
    rgb(1, 96, 153) 0%
  );
  border-radius: 9px;
  padding-inline: 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  overflow: hidden;
`;
